import { toRelativeUrl } from '@okta/okta-auth-js';
import { useOktaAuth } from '@okta/okta-react';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import PageLoadingSpinner from '../PageLoadingSpinner';

/**
 * SecureRoutes ensures that any nested routes
 * are only accessed if the user is authenticated in Okta.
 *
 * This ensures that access control is maintained in react-router v6
 */

export const SecureRoutes: React.FC = () => {
  const { oktaAuth, authState } = useOktaAuth();

  useEffect(() => {
    if (authState?.isAuthenticated === false) {
      const originalUri = toRelativeUrl(
        window.location.href,
        window.location.origin
      );
      oktaAuth.setOriginalUri(originalUri);
      void oktaAuth.signInWithRedirect();
    }
  }, [authState?.isAuthenticated, oktaAuth]);

  if (authState?.isAuthenticated !== true) {
    return <PageLoadingSpinner />;
  } else {
    return <Outlet />;
  }
};
